import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DateModule } from '@epicuro-next/ataraxia/date';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';

import { InputDateRangeComponent } from './input-date-range.component';

@NgModule({
  declarations: [InputDateRangeComponent],
  imports: [
    CommonModule,
    DateModule,
    PopoverModule,
    IconsModule,
    ReactiveFormsModule,
  ],
  exports: [InputDateRangeComponent],
  providers: [DatePipe],
})
export class InputDateRangeModule {}
